import React from "react";
import "./successform.css";

function SuccesForm() {
  return (
    <div className="submitform-wrapper">
      <div>
        <img
          src={"/images/formsuccessimage.svg"}
          alt=""
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="submitform-heading-wrapper">
        <div className="submitform-heading">
          <span>Thank you for your interest</span>
          <span>Your BeFiSc journey begins here!</span>
        </div>
        <span>You will hear from us soon</span>
      </div>
    </div>
  );
}

export default SuccesForm;
